import type { StaticTextResource } from '../keys'

export const vi: StaticTextResource = {
  'schedule.dueToday': 'Đến {{time}} hôm nay',
  'schedule.dueTomorrow': 'Đến {{time}} ngày mai',
  'schedule.durationRange':
    '{{start}} - {{end}} (Ngày {{currentDay}}/{{days}} ngày)',
  'editReport.defaultPageName': 'Trang {{n}}',
  'editReport.defaultSectionName': 'Phần',
  'editReport.defaultRepeatSectionName': 'Phần lặp lại',
}
